import { z } from 'zod'

/**
 * 체험학습 클래스 정보 스키마
 */
export const TrialClassSchema = z.object({
  class_id: z.string(),
  class_level: z.string(),
  class_week: z.string().optional().nullable(),
  class_course_id: z.string().optional().nullable(),
  lang_type: z.string(),
  // 레거시 수업 행에는 CLASS_TICKET_ID 가 비어 있을 수 있다
  class_ticket_id: z.string().nullable(),
  invoice_status: z.string(),
  class_status: z.string(),
})

export type TrialClass = z.infer<typeof TrialClassSchema>

/**
 * 체험학습 클래스 목록 응답 스키마
 */
export const TrialClassListSchema = z.array(TrialClassSchema)

export type TrialClassList = z.infer<typeof TrialClassListSchema>
